import {
  initializeForm,
  appendAndGetUniqueFormElement,
} from '../../../utils/form';
import { ADDITIONAL_DETAILS_EVENTS } from '../../../event_bus_modules/additional_details';
import { validateWhatIsYourOccupation } from '../../../utils/validators';

$(() => {
  const DISPLAY_NONE_CLASS = 'd-none';

  const whatIsYourOccupation = $('.what-is-your-occupation');

  const initializeWhatIsYourOccupationSection = (htmlElement) => {
    const element = $(htmlElement);

    const whatIsYourOccupationStatusSelect = element.find(
      "input[name='occupation_status']"
    );
    const whatIsYourOccupationSection = element.find(
      '#what-is-your-occupation-section'
    );
    const whatIsYourOccupationSelect = element.find(
      "input[name='occupation_status_option']"
    );
    const whatIsYourOccupationOtherSection = element.find(
      '#what-is-your-occupation-other-section'
    );
    const whatIsYourOccupationOtherInput = element.find(
      "input[name='occupation_other']"
    );

    const isSelfValidated = element.hasClass('self-validated');
    const isRequired = element[0].hasAttribute('required');

    const secondDropdownVisibleStatuses = [
      'employed',
      'self-employed',
      'retired',
    ];

    const clearOtherInput = () => {
      whatIsYourOccupationOtherInput.val('');
      const clearInput = new CustomEvent('inputChange', {
        detail: {
          value: '',
          resetFieldState: true,
        },
      });

      whatIsYourOccupationOtherInput.get(0).dispatchEvent(clearInput);
    };

    if (isSelfValidated && isRequired) {
      const whatIsYourOccupationForm = appendAndGetUniqueFormElement({
        $elementToAppend: $('#auction-registration-content'),
      });
      initializeForm(whatIsYourOccupationForm, {
        formFieldsWrapper: element,
        preventDefault: true,
        validate: (values) => {
          const errors = {
            ...validateWhatIsYourOccupation(values),
          };
          const hasErrors = !$.isEmptyObject(errors);

          const eventType = hasErrors
            ? ADDITIONAL_DETAILS_EVENTS.ADD_ERROR
            : ADDITIONAL_DETAILS_EVENTS.REMOVE_ERROR;

          EVENT_BUS.dispatch(eventType, {
            error: ADDITIONAL_DETAILS_EVENTS.ERROR.OCCUPATION,
          });

          return errors;
        },
      });
    }

    const handleOccupationStatusSelectChange = ($event) => {
      const status = $event.target.defaultValue;
      const statusHasOccupation = secondDropdownVisibleStatuses.includes(
        status
      );
      const occupation = whatIsYourOccupationSelect.get(0).defaultValue;

      if (occupation === 'other') {
        whatIsYourOccupationOtherSection.removeClass(DISPLAY_NONE_CLASS);
        whatIsYourOccupationOtherInput.removeClass(DISPLAY_NONE_CLASS);
      } else {
        whatIsYourOccupationOtherSection.addClass(DISPLAY_NONE_CLASS);
        whatIsYourOccupationOtherInput.addClass(DISPLAY_NONE_CLASS);
      }
      whatIsYourOccupationSection.toggleClass(
        DISPLAY_NONE_CLASS,
        !statusHasOccupation
      );
      if (!statusHasOccupation) {
        // if status has no occupation reset occupation select and other input states and visibility
        const clearSelect = new CustomEvent('clearSelect');
        whatIsYourOccupationSelect.get(0).dispatchEvent(clearSelect);
        clearOtherInput();
      }
    };

    const handleOccupationSelectChange = ($event) => {
      const occupation = $event.target.defaultValue;
      const occupationIsOther = occupation === 'other';
      whatIsYourOccupationOtherSection.toggleClass(
        DISPLAY_NONE_CLASS,
        !occupationIsOther
      );
      if (occupationIsOther) {
        whatIsYourOccupationOtherInput.removeClass(DISPLAY_NONE_CLASS);
      } else {
        whatIsYourOccupationOtherInput.addClass(DISPLAY_NONE_CLASS);
        // if occupation is different than other then reset other input state
        clearOtherInput();
      }
    };
    const occupationStatusValue = whatIsYourOccupationStatusSelect.val();
    const occupationValue = whatIsYourOccupationSelect.val();

    whatIsYourOccupationStatusSelect.on(
      'change',
      handleOccupationStatusSelectChange
    );
    whatIsYourOccupationSelect.on('change', handleOccupationSelectChange);

    if (secondDropdownVisibleStatuses.includes(occupationStatusValue)) {
      whatIsYourOccupationSection.removeClass(DISPLAY_NONE_CLASS);
    }
    if (occupationValue === 'other') {
      whatIsYourOccupationOtherSection.removeClass(DISPLAY_NONE_CLASS);
    }
  };

  whatIsYourOccupation.each((_, element) =>
    initializeWhatIsYourOccupationSection(element)
  );
});
